import React from 'react';
import { getButtonLoaderSize } from 'utils/helpers';
import { Loader } from 'components';
import { Button } from '@mui/material';
import { useSmallScreen } from 'utils/hooks/ui';

const CustomButton = ({ label, onClick, loading, noMargin, disabled, sx, ...rest }) => {
    const isSmallScreen = useSmallScreen();

    return (
        <Button
            variant="outlined"
            component="span"
            {...rest}
            disableRipple
            disableElevation
            fullWidth={isSmallScreen}
            onClick={onClick}
            sx={theme => ({
                marginRight: noMargin ? 0 : '20px',
                marginLeft: noMargin ? 0 : '20px',
                padding: '5px 8px',
                borderRadius: '5px',
                [theme.breakpoints.down(695)]: {
                    margin: 0,
                    marginBottom: '5px',
                },
                ...(typeof sx === 'function' ? sx(theme) : sx),
            })}
            disabled={loading || disabled}
        >
            <Loader
                loading={loading}
                color="inherit"
                size={getButtonLoaderSize(rest.size)}
                marginTop={0}
            >
                {label}
            </Loader>
        </Button>
    );
};

export default CustomButton;
